/*
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-12 15:51:23
 * @LastEditTime: 2021-03-04 15:31:09
 */
import i18n from "@/common/lang";
export const Columns = [
  { LabelName: i18n.t('lang.devicelist.SerialNumber'), row: 80, align: 'center', key: 0, ColumnsKey: 'Index', slot: true},
  { LabelName: '序列号', key: 1, ColumnsKey: 'deviceSn', seek: 'deviceSn', placeholder: '序列号', sort: 'custom'},
  { LabelName: '名称', key: 2, ColumnsKey: 'deviceName', placeholder: '设备名称', seek: 'deviceName' },
  { LabelName: i18n.t('lang.devicelist.Equipment'), key: 3, ColumnsKey: 'groupName', seek: 'deviceGname', placeholder: i18n.t('lang.devicelist.search2'), sort: 'custom'  },
  { LabelName: i18n.t('lang.devicelist.statevoid'), align: 'center', key: 4, ColumnsKey: 'deviceIsconnected', Tag: true, placeholder: i18n.t('lang.devicelist.search5'),seek: 'deviceIsconnected', Fun: 'GetStatus', sort: 'custom'},
  { LabelName: 'IP地址', key: 5, ColumnsKey: 'deviceIp',placeholder: i18n.t('lang.devicelist.search2')},
  { LabelName: i18n.t('lang.devicelist.Version'), key: 6, ColumnsKey: 'deviceSoftwareVer', seek: 'deviceSoftwareVer', placeholder: i18n.t('lang.devicelist.search11'), sort: 'custom'  },
  { LabelName: '设备地址', key: 7, ColumnsKey: 'deviceAddress', placeholder: i18n.t('lang.devicelist.search2')},
]